// Hour Type is hidden in the app (duty forms, rota form, Edit Duty > Times, Settings) -
// every tenant runs on Standard Hour, and bank holiday pay comes from the date, not the
// hour type. It's hidden, not removed: existing duties keep theirs, and every duty still
// needs one - pay/bill multiply by its pay/bill multiplier, and wfc-server reads
// hourTypeId when duties are saved, copied and loaded from a rota.
// Set to true to bring the Hour Type fields and the Settings page back.
export const SHOW_HOUR_TYPE = false;

// the hour type a duty gets when nobody picks one: Standard Hour, or the first there is
export const defaultHourTypeId = (hourTypes) => {
    const list = hourTypes || [];
    return (list.find((hour) => /standard/i.test(hour?.name || "")) || list[0])?._id || null;
};
